import React from 'react';
import { ContentProps } from '../../models/TopLevelTemplateComponentProps';
import { Palette } from 'Palette';
import StyledSection from '../styles/StyledSection';
import { StyledHeading } from '../styles/styles';

export interface SubtitleProps {
  heading: ContentProps;
  id?: string;
  tone?: keyof typeof Palette;
  firstElement?: boolean;
}

/**
 * A single heading with no body — a section break inside a longer page. Styled on
 * its own (`subtitle-block`) so it can diverge from StandardHeaderText; it starts
 * out matching that block's heading.
 */
export default function Subtitle({ heading, id, tone = 'tone1', firstElement }: SubtitleProps) {
  const text = heading?.content?.trim();
  if (!text) return null;
  return (
    <StyledSection
      id={id}
      noSidePaddingFrom="xs"
      noTopPadding={!firstElement}
      tone={tone}
      additionalClassName="subtitle-block-section content-management-item"
    >
      <StyledHeading tone={tone} headerVariant="heading2" className="subtitle-block">
        {text}
      </StyledHeading>
    </StyledSection>
  );
}
